import { useEffect, useState, type ReactNode } from "react";
import { ThemeContext } from "./ThemeContext";
import { createThemeFromConfig, type ThemeMode } from "../../layouts/themes";
import type { BaseTheme } from "api/dist/models/BaseTheme";
import { ThemesApi } from "api/dist/apis/ThemesApi";
import type { ThemeList } from "api";
import { useApi } from "../../hooks/useApi";

type Props = {
  mode?: ThemeMode;
  setMode?: (mode: ThemeMode) => unknown;
  themes?: ThemeList;
  children?: ReactNode;
};

export const ThemeContextProvider = (props: Props) => {
  const [mode, setMode] = useState<ThemeMode>("light");
  const [serverTheme, setServerTheme] = useState<BaseTheme>();
  const themeApi = useApi(ThemesApi);

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const fetchedTheme = await themeApi.apiThemesGet();
        setServerTheme(fetchedTheme);
      } catch (error) {
        console.error("Error fetching theme:", error);
      }
    };
    if (!props.themes) {
      fetchTheme();
    }
  }, [props.themes, themeApi]);

  const themes = createThemeFromConfig(
    props.themes ?? serverTheme?.themes ?? undefined,
  );
  const theme = themes[mode];

  return (
    <ThemeContext.Provider
      value={{
        mode: props.mode === undefined ? mode : props.mode,
        setMode: props.setMode === undefined ? setMode : props.setMode,
        themes: props.themes ?? (serverTheme?.themes as ThemeList),
        muiTheme: theme,
        muiThemes: themes,
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};
